var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.changeOrderSlug)?_c('project-change-orders'):_c('project-change-order',{attrs:{"change-order-slug":_vm.changeOrderSlug},on:{"slugChange":_vm.setSlug}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }